// Import branding configuration
import { getBranding } from './config/branding';

const isSandbox = (process.env.REACT_APP_ENV || 'sandbox') === 'sandbox';
const branding = getBranding();

// Payment Gateway Configuration (supports Maya Checkout)
const getPublicKey = () => {
    if (isSandbox) {
        return process.env.REACT_APP_MAYA_SANDBOX_PUBLIC_KEY 
            || process.env.REACT_APP_SANDBOX_PUBLIC_KEY 
            || process.env.REACT_APP_CHECKOUT_PUBLIC_API_KEY 
            || '';
    }
    return process.env.REACT_APP_MAYA_PRODUCTION_PUBLIC_KEY || process.env.REACT_APP_PRODUCTION_PUBLIC_KEY || '';
};

const getSecretKey = () => {
    if (isSandbox) {
        return process.env.REACT_APP_MAYA_SANDBOX_SECRET_KEY 
            || process.env.REACT_APP_SANDBOX_SECRET_KEY 
            || process.env.REACT_APP_CHECKOUT_SECRET_API_KEY 
            || '';
    }
    return process.env.REACT_APP_MAYA_PRODUCTION_SECRET_KEY
        || process.env.REACT_APP_PRODUCTION_SECRET_KEY 
        || '';
};

const config = {
    // App URLs
    host_url: process.env.REACT_APP_HOST_URL || 'http://localhost:3000',
    path_prefix: process.env.REACT_APP_PATH_PREFIX || '/',
    admin_password: process.env.REACT_APP_ADMIN_PASSWORD || '',
    appscript_url: process.env.REACT_APP_APPSCRIPT_URL || '',
    api_key: process.env.REACT_APP_API_KEY || '',
    
    // Groq AI
    groq_key: process.env.REACT_APP_GROQ_KEY || '',
    
    // Branding
    branding: branding,
    
    // Payment Gateway
    payment_gateway: {
        url: isSandbox 
            ? 'https://pg-sandbox.paymaya.com/checkout/v1/checkouts'
            : 'https://pg.paymaya.com/checkout/v1/checkouts',
        pub_api_key: getPublicKey(),
        sec_api_key: getSecretKey(),
    },
    
    // Contact Information (for customer support)
    contact: {
        email: process.env.REACT_APP_SUPPORT_EMAIL || '',
        phone: process.env.REACT_APP_SUPPORT_PHONE || '',
    },
}
  
export default config
